<template>
  <div>
    <CategoryEditorNav />
    <CategoryStepper step="2" />
    <div class="container loader" :class="{hidden: !categoryLoading}">
      <div class="progress">
        <div class="indeterminate"></div>
      </div>
    </div>
    <div class="container" :class="{hidden: categoryLoading}">
      <h2>Assign and Organize Content for this Category</h2>

      <div id="step1">
        <div class="row">
          <div class="col l4 m4">
              {{title}}
              <div id="snaptarget" class="ui-widget-header">
                <p>Drag tutorials and quizzes here that you want included. You can reorder the content by dragging it to the order you need</p>
                <ul id="sortable_category" class="connectedSortable droptrue" >
                    <li class="ui-state-disabled">&nbsp;</li>
                    
                    <li style="border-style:none !important;"
                    :key="i"
                    v-for="(contenter, i) in content"
                    class="ui-state-default"
                    :data-order="i"
                    :id="contenter.id">
                    <div class="card horizontal" >
                        <div class="card-image" style="width:40px;text-align:center"
                        :style="{backgroundColor: chooseColor(contenter.type) }">
                            <p>
                            <span style="font-size:12px;color:#fff">{{contenter.type}}</span>
                            </p>
                        </div>
                        <div class="card-stacked">
                            <div class="card-content">
                                <a class="modal-trigger"
                                    style="color:#000"
                                    href="#modal1"
                                    
                                >{{contenter.title}}</a>
                                <i class="material-icons right" style="font-size:20px;">dehaze</i>
                                <a 
                                    onMouseOver="this.style.cursor='pointer'"
                                    :data-id="contenter.id"
                                    :data-title="contenter.title.replace(/_/g, ' ')"
                                        v-on:click='removeFromCategory(contenter.id)'>
                                <i class="material-icons right" style="font-size:20px;">remove_circle_outline</i></a>
                                
                            </div>
                        </div>
                    </div>
                </li>
                
                </ul>
              </div>
          </div>
          <div class="col l4 m4">
              Tutorials 
            <div class="progress" v-if="tutorialsLoading">
                <div class="indeterminate"></div>
            </div>
            <div id="tutorials" v-if="!tutorialsLoading">
                <div class="alert alert-danger" v-if="error">
                    <p v-if="error" class="error red-text">There was an error loading tutorials: {{ error.message }}</p>
                </div>
              <div style="display:block;overflow:auto;height:500px !important;">
              <ul id="sortablea" class="">
                <li style="border-style:none !important;"
                    :key="i"
                    v-for="(tutorial, i) in tutorials"
                    class="ui-state-default"
                    :class="{'ui-state-disabled': isIncludedInCategory(tutorial.id)}"
                    :data-order="i"
                    :id="tutorial.id">
                    <div class="card horizontal" >
                        <div class="card-image" style="width:40px;text-align:center"
                        :style="{backgroundColor: colors[0] }">
                            <p>
                            <span style="font-size:12px;color:#fff">tutorial</span>
                            </p>
                        </div>
                        <div class="card-stacked">
                            <div class="card-content">
                                <a class="modal-trigger"
                                    style="color:#000"
                                    href="#modal1"
                                    
                                >{{tutorial.title}}</a>
                                <i class="material-icons right" style="font-size:20px;">dehaze</i>
                            </div>
                        </div>
                    </div>
                </li>
              </ul>
              </div>
            </div>
          </div>
          <div class="col l4 m4">
              Quizzes
            <div class="progress" v-if="quizzesLoading">
                <div class="indeterminate"></div>
            </div>
            <div id="quizzes" v-if="!quizzesLoading">
                <div class="alert alert-danger" v-if="error">
                    <p v-if="error" class="error red-text">There was an error loading quizzes: {{ error.message }}</p>
                </div>
                <div style="display:block;overflow:auto;height:500px !important;">
                <ul id="sortableq" class="">
                <li style="border-style:none !important;"
                    :key="i"
                    v-for="(quiz, i) in quizzes"
                    class="ui-state-default"
                    :class="{'ui-state-disabled': isIncludedInCategory(quiz.id)}"
                    :data-order="i"
                    :id="quiz.id"
                >
                    <div class="card horizontal" >
                    <div class="card-image" style="width:40px;text-align:center"
                    :style="{backgroundColor: colors[1] }">
                        <p>
                        <span style="font-size:16px;color:#fff">quiz</span>
                        </p>
                    </div>
                    <div class="card-stacked">
                        <div class="card-content">
                        <a class="modal-trigger"
                            style="color:#000"
                            href="#modal1"
                            
                        >{{quiz.title}}</a>
                        <i class="material-icons right" style="font-size:20px;">dehaze</i>
                        
                        </div>
                    </div>
                    </div>
                </li>
                </ul>
                </div>
            </div>
          </div>

          <div v-if="embeddableCategories" class="col l3 m3">
              Categories
            <div class="progress" v-if="categoriesLoading">
                <div class="indeterminate"></div>
            </div>
            <div id="cateories" v-if="!categoriesLoading">
                <div class="alert alert-danger" v-if="error">
                    <p v-if="error" class="error red-text">There was an error loading categories: {{ error.message }}</p>
                </div>

                <ul id="sortablecat" class="">
                <li style="border-style:none !important;"
                    :key="i"
                    v-for="(category, i) in filteredCategories"
                    class="ui-state-default"
                    :class="{'ui-state-disabled': isIncludedInCategory(category.id)}"
                    :data-order="i"
                    :id="category.id"
                >
                    <div class="card horizontal" >
                    <div class="card-image" style="width:40px;text-align:center"
                    :style="{backgroundColor: colors[2] }">
                        <p>
                        <span style="font-size:10px;color:#fff">category</span>
                        </p>
                    </div>
                    <div class="card-stacked">
                        <div class="card-content">
                        <a class="modal-trigger"
                            style="color:#000"
                            href="#modal1"
                            
                        >{{category.title}}</a>
                        <i class="material-icons right" style="font-size:20px;">dehaze</i>
                        
                        </div>
                    </div>
                    </div>
                </li>
                </ul>
            </div>
          </div>  

        </div>
        <div class="fab-next">
          <a
            class="btn btn-large blue"
            :class="{disabled: !canGoNext}"
            @click="nextClick()"
          >Done
            <i class=" material-icons right">chevron_right</i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
<script>

import CategoryEditorNav from "@/components/CategoryEditorNav";
import CategoryStepper from "@/components/CategoryStepper";

import Sidebar from "@/components/Sidebar";
import cognitoAuth from "@/plugins/cognito";
import GqlQuery from "@/plugins/gql";
import GqlV2Query from "@/plugins/gqlV2"

import 'isomorphic-fetch'

let gql_endpoint = process.env.GQL_ENDPOINT
let gqlv2_endpoint = process.env.GQL_V2_ENDPOINT
let read_gql_endpoint = process.env.READGQL_ENDPOINT


export default {
  mounted() {
      let jqueryui = document.createElement('script')
      jqueryui.setAttribute('src','https://code.jquery.com/ui/1.12.1/jquery-ui.js' )
      document.body.appendChild(jqueryui)

    let self = this
    document.title = "fyiio | category editor";
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
    });
    setTimeout(function() {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
    }, 500);

    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function(err, user_attributes) {
          self.user_org = user_attributes['custom:organization_id'];
          self.organization_id=self.user_org,
          self.user_email = user_attributes['email']
          self.user_id = user_attributes['sub']

          if (self.id) {
            self.loadCategory();
            self.loadCategories();
            self.loadQuizzes();
            self.loadTutorials();
          } else {
            self.categoryLoading = false;
          }
        });
      }
    });
  },
  updated() {},
  name: "NewCategoryTemplate",
  data() {
    return {
      embeddableCategories:false,
      constituents:{},
      categoryJson:[],
      colors: ["#25aae1", "#8cc63f", "#f172a6", "#13a89e", "#fcb040", "#8cc63f"],
      title: "",
      error:"",
      description: "",
      content:[],
      contentMap:[],
      id: this.$route.params.id,
      organization_id: "", 
      user_id: false,
      user_org: false,
      user_email: false,
      categoryLoading: true,
      categories: [],
      categoriesLoading: true, 
      quizzes: [],
      quizzesLoading: true, 
      tutorials: [], 
      tutorialsLoading: true,
    };
  },
  computed: {
    filteredCategories() {
      var self = this;
      return self.categories.filter(item => self.id!=item.id);
    }, 
    canGoNext() {
      return (
        this.title.length > 0 &&
        this.description.length > 0 
      );
    }
  },
  updated: function () {
  this.$nextTick(function () {
      let self = this;
      self.initSortables()
    })
  },
  methods: {
    loadCategories() {
      var self = this;
      let variables={}
      GqlV2Query.getCategories(variables, (err, result) => {
            if (err) {
              this.error = err;
            } else {
              self.categories = result.data.category;
              self.categoriesLoading = false;

              for(let i=0; i<self.categories.length;i++){
                        self.constituents[self.categories[i].id]={}
                        self.constituents[self.categories[i].id]['type']="category"
                        self.constituents[self.categories[i].id]['title']=self.categories[i].title
              }
              M.AutoInit();
            }
        }
      )
    },
    removeFromCategory(id){
        let self = this;
        var currentCategory=$("#sortable_category").sortable('toArray')
        self.persistCategoryMembersAndOrder(currentCategory.filter(function(valzer, index, arr){return valzer!=id}))
    },
    sortIncludedInCategory(a, b){
       let self = this; 
       return self.contentMap.indexOf(a.id) - self.contentMap.indexOf(b.id);
    },
    isIncludedInCategory(id){
        let self = this;
        return self.contentMap.includes(id)
    },
    chooseColor(typer){
        let self = this;
        if(typer=='tutorial'){
            return self.colors[0]
        }else if(typer=='quiz'){
            return self.colors[1]
        }else{
            return self.colors[2]
        }
    },
    initSortables(){
        let self = this;
        $( "#sortableq, #sortablea, #sortablecat" ).sortable({
            cancel: '.edutable .ui-state-default',
            connectWith: ".connectedSortable"
        });
        $( "#sortable_category").sortable({
            connectWith: ".connectedSortable",
            cancel: ".ui-state-disabled .editable",
            update: function(event, ui) {
                var categoryOrder = $(this).sortable('toArray');
                self.persistCategoryMembersAndOrder(categoryOrder);   
               },
      revert: true
        }).disableSelection();
    },
    persistCategoryMembersAndOrder(categoryOrder){
        let self = this;
        self.categoryJson=[];
        //use map instead
        categoryOrder.forEach(function(categoryMember, index, array){
            if(categoryMember!=''){
                let holdMember={}
                holdMember={}
                holdMember.id=categoryMember
                holdMember.title=self.constituents[categoryMember]['title']
                holdMember.type=self.constituents[categoryMember]['type']
                self.categoryJson.push(holdMember)
            }
        })
        
        let variables = {}
        variables.id=self.id;
        variables.content=self.categoryJson
        GqlV2Query.updateCategoryContent(variables, (err, result) => {
            if (err) {
            this.error = err;
            M.toast({
                html:
                "There was an error updating your quiz, please try again or contact Fyiio support",
                inDuration: 300,
            });
            } else {
                window.location = "/categories/build/" + self.id
                /*M.toast({
                    html:
                    "The category content has been updated.",
                    completeCallback: function(){window.location = "/categories/build/" + self.id},
                    inDuration: 25,
                }); */
                
            }
        });
    },
    loadTutorials(){
        let self = this;
        GqlQuery.getArticles(function(err, response) {
            if (err) {
                self.error = err;
            }
            response.then(function(val) {
                console.log(response)
                if(val.data.articles.length>0){
                    let tutsuite=[]
                    let z=0;
                    for(z=0; z<val.data.articles.length;z++){
                      tutsuite=tutsuite.concat(val.data.articles[z].chapters)
                    }
                    //self.tutorials=val.data.articles[0].chapters.sort(self.sortIncludedInCategory)
                    self.tutorials=tutsuite.sort(self.sortIncludedInCategory);
                    self.tutorialsLoading = false;
                    let i=0;
                    for(i=0; i<self.tutorials.length;i++){
                        self.constituents[self.tutorials[i].id]={}
                        self.constituents[self.tutorials[i].id]['type']="tutorial"
                        self.constituents[self.tutorials[i].id]['title']=self.tutorials[i].title
                    }
                    M.AutoInit();
                }
            })
        })
    },
    loadCategory(){
      let self = this;
      GqlV2Query.getCategory(this.id,  (err, result) => {
        let category=result.data.category[0];
        self.category=category;
        self.originalCategory = category;
        self.title=category.title;
        self.description=category.description;
        self.categoryLoading = false;
        self.content=category.content
        if(self.content){
          self.contentMap = self.content.map(categoryMember => {
              return categoryMember.id
          })
        }
        M.AutoInit();
       
      });
    },
    loadQuizzes() {
      var self = this;
      let variables={
        organization_id: self.organization_id
      }
      GqlV2Query.getQuizzes(variables, (err, result) => {
            if (err) {
              this.error = err;
            } else {
              self.quizzes = result.data.quiz.sort(self.sortIncludedInCategory);
              self.quizzesLoading = false;
              let i=0;
              for(i=0; i<self.quizzes.length;i++){
                self.constituents[self.quizzes[i].id]={}
                self.constituents[self.quizzes[i].id]['type']="quiz"
                self.constituents[self.quizzes[i].id]['title']=self.quizzes[i].title
              }
              M.AutoInit();
            }
        }
      )
    },
    nextClick() {
      var self = this;
      if (!this.canGoNext) {
        return;
      }
      if (this.category) {
        //window.location = "/categories/preview/" + self.id;
        window.location="/categories"
      } 
    }
  },
  components: {
    CategoryEditorNav,
    CategoryStepper
  }
};
</script>

<style scoped>
#sortablea {
  height:50px !important;
}

#toast-container {
  min-width: 10%;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  margin-top: -69px;
}
.preloader-wrapper {
  margin-top: 9px;
}
h2 {
  color: #58595b;
  font-family: Roboto;
  font-size: 24px;
  line-height: 32px;
  margin-top: 60px;
  margin-bottom: 24px;
}
button {
  margin-left: 10px;
}
.time-to-complete {
  width: 352px;
}
.time-to-complete label {
  left: 0;
}
.right.helper-text {
  text-align: right;
}
.hidden {
  display: none;
}
.loader {
  margin-top: 100px;
}
.select-wrapper input.select-dropdown,
.dropdown-content li > span {
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: lowercase;
}

.fab-next {
  float: right;
  padding-top: 42px;
  padding-bottom: 42px;
}
#description {
  margin-top: 8px;
}
</style>
<style >
.select-wrapper input.select-dropdown {
  text-transform: lowercase !important;
}
.select-wrapper .dropdown-content li > span,
ul.dropdown-content.select-dropdown li span {
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: lowercase;
}
.btn-floating.blue {
  background-color: #58595b !important;
}
.btn-floating.blue.disabled {
  background-color: #f1f1f1 !important;
}

.progress {
  background-color: #7ac7e7;
}
.progress .determinate,
.progress .indeterminate {
  background-color: #29abe1;
}
</style>


// WEBPACK FOOTER //
// src/containers/dashboard/categories/BuildCategory.vue